import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { AlertService } from '../../alert';
import { InventoryService } from '../../services/inventory.service';
import { StorageService } from 'app/services/storage.service';
import { AuthenticationService, Token } from '../../services';
import { Article } from './article';

@Component({
  selector: 'app-article-detail',
  providers: [InventoryService, StorageService],
  templateUrl: './article-detail.component.html',
  styleUrls: ['./article-detail.component.css']
})
export class ArticleDetailComponent implements OnInit {

  loading = false;
  article: Article;
  saved = false;
  shelves: any[] = [];
  shelfName: string = null;
  messageType: string = "INFO";
  messageText: string = null;

  constructor(
    private inventoryService: InventoryService,
    private storageService: StorageService,
    private route: ActivatedRoute,
    private alertService: AlertService,
    private authenticationService: AuthenticationService) { }

  ngOnInit() {
    let reference = this.route.snapshot.params['id'];
    if (reference == "new") {
      this.article = new Article();
    } else {
      this.getArticle(reference);
    }
  }

  deleteShelf(event) {
    this.loading = true;
    this.shelves = [];
    this.inventoryService.deleteShelf(this.article.articleRef, event.name)
      .subscribe(
        data => {
          this.loading = false;
          this.alertService.success("Lagerplatz erfolgreich gelöscht");
          this.getShelves(this.article.articleRef);
          this.messageType = "INFO";
          this.messageText = "Lagerplatz erfolgreich gelöscht";
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
          this.messageType = "ERROR";
          this.messageText = error;
        });
  }

  save() {
    this.loading = true;
    this.inventoryService.cuArticle(this.article)
      .subscribe(
        data => {
          this.alertService.success("Artikel erfolgreich gespeichert");
          this.getArticle(this.article.articleRef);
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });

  }

  updateShelf(model: any) {
    this.updateItems(this.article.articleRef, model.items, model.remark, model.shelf);
  }
  
  relocateArticle(model: any) {
    this.relocateItems(this.article.articleRef, model.items, model.shelf, model.newshelf, model.remark);
  }

  updateItems(reference: string, items: number, remark: string, shelf: string) {
    if (remark == null || remark == '') {
      this.alertService.error("Grund der Lagerveränderung fehlt");
      this.messageType = "ERROR";
      this.messageText = "Grund der Lagerveränderung fehlt";
      return;
    }
    this.loading = true;
    this.shelves = [];
    // validate that shelf (container) exists
    this.storageService.getContainer(shelf)
      .subscribe(data => {
        this.shelfName = data.name;
        if (!this.shelfName) {
            this.alertService.error("Not a valid shelf");
            this.loading = false;
            this.messageType = "ERROR";
            this.messageText = "Not a valid shelf";
            return;
        } else {
          this.inventoryService.changeItems(reference, items, remark, shelf, null)
            .subscribe(
              data => {
                this.alertService.success("Anzahl erfolgreich gespeichert");
                this.getArticle(this.article.articleRef);
                this.messageType = "INFO";
                this.messageText = "Anzahl erfolgreich gespeichert";
              },
              error => {
                this.alertService.error(error);
                this.loading = false;
                this.messageType = "ERROR";
                this.messageText = error;
              });
        }
      }, error => {this.shelfName = null;});
  }



  relocateItems(reference: string, items: number, shelf: string, newshelf: string, remark: string) {
    if (remark == null || remark == '') {
      remark = "Umlagerung";
    }
    if (newshelf == null|| newshelf == ''){
      this.alertService.error("Das Feld Zu Shelf darf nicht leergelassen werden");
      this.messageType = "ERROR";
      this.messageText = "Das Feld Zu Shelf darf nicht leergelassen werden";
      return;
    }
    this.loading = true;
    this.shelves = [];
    // validate that shelf (container) exists
    this.storageService.getContainer(shelf)
    .subscribe(data => {
      this.shelfName = data.name;
      this.storageService.getContainer(newshelf)
      .subscribe(data => {
        this.inventoryService.changeItems(reference, items, remark, shelf, newshelf).subscribe(
            data=>{
              this.alertService.success("Umlagerung erfolgreich durchgeführt");
              this.getArticle(this.article.articleRef)
              this.messageType = "INFO";
              this.messageText = "Umlagerung erfolgreich durchgeführt";
            },
            error=>{
              this.alertService.error(error);
              this.loading = false;
              this.messageType = "ERROR";
              this.messageText = error;
          } 
        )
      },
      error => {
          this.alertService.error("Newshelf not valid");
          this.loading = false;
          this.messageType = "ERROR";
          this.messageText = "Newshelf not valid";
          return;
      });
    },
    error => {
        this.alertService.error("Shelf not valid");
        this.loading = false;
        this.messageType = "ERROR";
        this.messageText = "Shelf not valid";
        return;
    });
  }

  getShelves(reference: string) {
    this.loading = true;
    this.inventoryService.getShelves(reference)
      .subscribe(
        data => {
          for (let item of data) {
            if (item.storage == this.authenticationService.getStorageName()) {
              this.shelves.push(item);
            }
          }
          // this.shelves = data; do not add all. Only the ones for this warehouse
          this.article.items = 0;
          for (let shelf of this.shelves) {
            this.article.items = this.article.items + shelf.numberOfItems;
          }
          this.loading = false;
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }

  getArticle(reference: string) {
    this.loading = true;
    this.inventoryService.getArticle(reference)
      .subscribe(
        data => {
          this.article = data;
          this.saved = true;
          this.loading = false;
          this.getShelves(reference);
        },
        error => {
          this.alertService.error(error);
          this.loading = false;
        });
  }


}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/inventory/article-detail/article-detail.component.ts